import { AUTH_OTP } from "../modules/constants";

export async function authOTP(data) {
  const url = AUTH_OTP;

  const config = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      // "app-version": "7.4.0",
      // "app-platform": "pwa",
    },
    body: JSON.stringify(data),
  };

  const response = await fetch(url, config);

  const responseData = await response.json();

  return {
    data: responseData,
    status: response.status,
    statusText: response.statusText,
    headers: Object.fromEntries(response.headers.entries()),
    config,
    request: response,
  };
}
